import React, { useMemo } from 'react'
import { Tag } from 'antd'
import { UserRole } from '../../../types/user'
import { UserRoleMapper } from '../../../constants/user'

interface Props {
  roles: UserRole[]
  merchant?: string
}

const UserRoleTag = (props: Props) => {
  const { roles, merchant } = props

  const { color, text, role } = useMemo(() => {
    if (roles.includes(UserRole.ADMIN)) {
      return {
        text: UserRoleMapper.ADMIN,
        color: '#108ee9',
        role: UserRole.ADMIN,
      }
    }
    if (roles.includes(UserRole.ADVERTISER)) {
      return {
        text: UserRoleMapper.ADVERTISER,
        color: '#f50',
        role: UserRole.ADVERTISER,
      }
    }
    if (roles.includes(UserRole.HEAD)) {
      return {
        text: UserRoleMapper.HEAD,
        color: '#2db7f5',
        role: UserRole.HEAD,
      }
    }
    if (roles.includes(UserRole.MERCHANT)) {
      return {
        text: UserRoleMapper.MERCHANT,
        color: '#aa68d0',
        role: UserRole.MERCHANT,
      }
    }
    return {
      text: UserRoleMapper.USER,
      color: '#87d068',
      role: UserRole.USER,
    }
  }, [roles])
  return (
    <Tag color={color} key={role} style={{ margin: 0 }}>
      {text} {merchant ? ` [${merchant}]` : ''}
    </Tag>
  )
}

export default UserRoleTag
